
import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Eye, ArrowRight, Home, Building, Bed, ChefHat, Bath, Briefcase } from 'lucide-react';

const ProjectPortfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
  { id: 'all', name: 'Todos', icon: <Home className="w-4 h-4" data-id="bxpangsva" data-path="src/components/ProjectPortfolio.tsx" /> },
  { id: 'residential', name: 'Residencial', icon: <Home className="w-4 h-4" data-id="y6h4xuyqc" data-path="src/components/ProjectPortfolio.tsx" /> },
  { id: 'commercial', name: 'Comercial', icon: <Building className="w-4 h-4" data-id="abzlbzbqc" data-path="src/components/ProjectPortfolio.tsx" /> },
  { id: 'bedroom', name: 'Recámaras', icon: <Bed className="w-4 h-4" data-id="j2zj1bcqr" data-path="src/components/ProjectPortfolio.tsx" /> },
  { id: 'kitchen', name: 'Cocinas', icon: <ChefHat className="w-4 h-4" data-id="y0v1nyjlo" data-path="src/components/ProjectPortfolio.tsx" /> },
  { id: 'bathroom', name: 'Baños', icon: <Bath className="w-4 h-4" data-id="rk6bfl9aw" data-path="src/components/ProjectPortfolio.tsx" /> },
  { id: 'office', name: 'Oficinas', icon: <Briefcase className="w-4 h-4" data-id="pkujc3r1a" data-path="src/components/ProjectPortfolio.tsx" /> }];


  const projects = [
  {
    id: 1,
    title: 'Casa Inteligente Las Lomas',
    category: 'residential',
    location: 'Las Lomas, CDMX',
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop',
    description: 'Automatización completa de residencia de 400m² con control de iluminación, climatización, seguridad y entretenimiento.',
    technologies: ['HomeSeer', 'Lutron', 'Sonos', 'Nest'],
    results: ['40% ahorro energético', '100% control remoto', '24/7 seguridad'],
    investment: '$180,000',
    spaces: ['Salas', 'Recámaras', 'Cocina', 'Jardín'],
    size: '400m²'
  },
  {
    id: 2,
    title: 'Penthouse Inteligente',
    category: 'residential',
    location: 'Polanco, CDMX',
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&h=400&fit=crop',
    description: 'Penthouse de lujo con automatización premium, control por voz y sistema de entretenimiento integrado.',
    technologies: ['HomeSeer', 'Fibaro', 'Bose', 'Philips Hue'],
    results: ['Control total por voz', 'Integración premium', 'Ahorro 35%'],
    investment: '$250,000',
    spaces: ['Sala principal', 'Recámara master', 'Terraza', 'Estudio'],
    size: '300m²'
  },
  {
    id: 3,
    title: 'Oficina Corporativa',
    category: 'commercial',
    location: 'Santa Fe, CDMX',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop',
    description: 'Automatización de oficina corporativa con control de acceso, climatización inteligente y sistema de conferencias.',
    technologies: ['HomeSeer', 'Insteon', 'Cisco', 'Honeywell'],
    results: ['50% ahorro energético', 'Control de acceso', 'Productividad +20%'],
    investment: '$150,000',
    spaces: ['Oficinas', 'Salas de junta', 'Recepción', 'Áreas comunes'],
    size: '500m²'
  },
  {
    id: 4,
    title: 'Recámara Principal Smart',
    category: 'bedroom',
    location: 'Satelite, Edo. Mex',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=400&fit=crop',
    description: 'Recámara principal con iluminación circadiana, control de temperatura y sistema de entretenimiento integrado.',
    technologies: ['HomeSeer', 'Lutron', 'Nest', 'Sonos'],
    results: ['Mejor calidad de sueño', 'Confort optimal', 'Ahorro 30%'],
    investment: '$45,000',
    spaces: ['Recámara', 'Baño', 'Vestidor', 'Balcón'],
    size: '80m²'
  },
  {
    id: 5,
    title: 'Cocina Inteligente',
    category: 'kitchen',
    location: 'Coyoacán, CDMX',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop',
    description: 'Cocina moderna con electrodomésticos inteligentes, iluminación adaptativa y sistema de ventilación automatizado.',
    technologies: ['HomeSeer', 'Samsung', 'Lutron', 'Broan'],
    results: ['Cocina más eficiente', 'Menos desperdicio', 'Ahorro 25%'],
    investment: '$60,000',
    spaces: ['Cocina', 'Despensa', 'Comedor', 'Barra'],
    size: '50m²'
  },
  {
    id: 6,
    title: 'Baño Spa Inteligente',
    category: 'bathroom',
    location: 'Roma Norte, CDMX',
    image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=600&h=400&fit=crop',
    description: 'Baño principal convertido en spa con control de temperatura, iluminación y sistema de audio.',
    technologies: ['HomeSeer', 'Kohler', 'Lutron', 'Sonos'],
    results: ['Experiencia spa', 'Confort total', 'Ahorro agua 20%'],
    investment: '$35,000',
    spaces: ['Baño principal', 'Ducha', 'Tina', 'Tocador'],
    size: '25m²'
  },
  {
    id: 7,
    title: 'Estudio Profesional',
    category: 'office',
    location: 'Condesa, CDMX',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=400&fit=crop',
    description: 'Estudio de trabajo con iluminación adaptativa, control de ruido y sistema de videoconferencia profesional.',
    technologies: ['HomeSeer', 'Lutron', 'Bose', 'Logitech'],
    results: ['Productividad +40%', 'Menos fatiga', 'Mejor concentración'],
    investment: '$25,000',
    spaces: ['Estudio', 'Biblioteca', 'Área de reuniones'],
    size: '30m²'
  },
  {
    id: 8,
    title: 'Loft Moderno',
    category: 'residential',
    location: 'Centro Histórico, CDMX',
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&h=400&fit=crop',
    description: 'Loft urbano con automatización minimalista, control de iluminación y sistema de seguridad integrado.',
    technologies: ['HomeSeer', 'Insteon', 'Ring', 'Nest'],
    results: ['Seguridad 24/7', 'Control total', 'Ahorro 35%'],
    investment: '$95,000',
    spaces: ['Loft principal', 'Cocina', 'Recámara', 'Terraza'],
    size: '120m²'
  }];


  const filteredProjects = selectedCategory === 'all' ?
  projects :
  projects.filter((project) => project.category === selectedCategory);

  return (
    <section id="proyectos" className="py-20 bg-white" data-id="0n6ad4ggh" data-path="src/components/ProjectPortfolio.tsx">
      <div className="container mx-auto px-4" data-id="0gc70snrc" data-path="src/components/ProjectPortfolio.tsx">
        {/* Header */}
        <div className="text-center mb-16" data-id="53q5sbdfv" data-path="src/components/ProjectPortfolio.tsx">
          <Badge className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 text-sm font-medium mb-4" data-id="yvsqerx3e" data-path="src/components/ProjectPortfolio.tsx">
            🏆 Proyectos Exitosos
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-id="6slyxryvp" data-path="src/components/ProjectPortfolio.tsx">
            Nuestros
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" data-id="0w6gsra96" data-path="src/components/ProjectPortfolio.tsx"> Proyectos</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="eo6mj9tpd" data-path="src/components/ProjectPortfolio.tsx">
            Descubre cómo hemos transformado estudios, recámaras, cocinas, oficinas y baños en espacios inteligentes 
            para familias y empresas en toda la Ciudad de México.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="ceiz56af9" data-path="src/components/ProjectPortfolio.tsx">
          {categories.map((category) =>
          <Button
            key={category.id}
            variant={selectedCategory === category.id ? 'default' : 'outline'}
            onClick={() => setSelectedCategory(category.id)}
            className={`flex items-center space-x-2 ${
            selectedCategory === category.id ?
            'bg-gradient-to-r from-blue-600 to-purple-600 text-white' :
            'hover:bg-blue-50'}`
            } data-id="6pndg7u2p" data-path="src/components/ProjectPortfolio.tsx">

              {category.icon}
              <span data-id="c39dgjcmx" data-path="src/components/ProjectPortfolio.tsx">{category.name}</span>
            </Button>
          )}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="t7an916uu" data-path="src/components/ProjectPortfolio.tsx">
          {filteredProjects.map((project) =>
          <Card key={project.id} className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden" data-id="sdf1wfxa8" data-path="src/components/ProjectPortfolio.tsx">
              <div className="relative" data-id="tdjk0b3wb" data-path="src/components/ProjectPortfolio.tsx">
                <img
                src={project.image}
                alt={project.title}
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300" data-id="cuwpp5g0s" data-path="src/components/ProjectPortfolio.tsx" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="ado75q6id" data-path="src/components/ProjectPortfolio.tsx" />
                <div className="absolute bottom-4 left-4 right-4" data-id="pjiet190i" data-path="src/components/ProjectPortfolio.tsx">
                  <Badge className="bg-white/20 text-white backdrop-blur-sm mb-2" data-id="ih7f1skpq" data-path="src/components/ProjectPortfolio.tsx">
                    {project.size}
                  </Badge>
                  <h3 className="text-white font-bold text-lg" data-id="ktpx0i9e8" data-path="src/components/ProjectPortfolio.tsx">{project.title}</h3>
                  <p className="text-white/90 text-sm" data-id="7rnflk7qv" data-path="src/components/ProjectPortfolio.tsx">{project.location}</p>
                </div>
                <div className="absolute top-4 right-4" data-id="gb0bes4y7" data-path="src/components/ProjectPortfolio.tsx">
                  <Badge className="bg-blue-600 text-white" data-id="omo7giazc" data-path="src/components/ProjectPortfolio.tsx">
                    {project.investment}
                  </Badge>
                </div>
              </div>
              
              <CardContent className="p-6" data-id="8whg1ev41" data-path="src/components/ProjectPortfolio.tsx">
                <p className="text-gray-600 mb-4 text-sm leading-relaxed" data-id="pbif7lhm8" data-path="src/components/ProjectPortfolio.tsx">
                  {project.description}
                </p>
                
                <div className="space-y-4" data-id="x8je3f7nf" data-path="src/components/ProjectPortfolio.tsx">
                  <div data-id="my1mnerci" data-path="src/components/ProjectPortfolio.tsx">
                    <h4 className="font-semibold text-gray-800 mb-2 text-sm" data-id="4saxch03v" data-path="src/components/ProjectPortfolio.tsx">Tecnologías:</h4>
                    <div className="flex flex-wrap gap-2" data-id="28wjkkcpp" data-path="src/components/ProjectPortfolio.tsx">
                      {project.technologies.map((tech, techIndex) =>
                    <Badge key={techIndex} variant="secondary" className="text-xs" data-id="8b8zn13a2" data-path="src/components/ProjectPortfolio.tsx">
                          {tech}
                        </Badge>
                    )}
                    </div>
                  </div>
                  
                  <div data-id="1saq12wjs" data-path="src/components/ProjectPortfolio.tsx">
                    <h4 className="font-semibold text-gray-800 mb-2 text-sm" data-id="cfyla8ow1" data-path="src/components/ProjectPortfolio.tsx">Espacios:</h4>
                    <div className="flex flex-wrap gap-2" data-id="tlsilq6l2" data-path="src/components/ProjectPortfolio.tsx">
                      {project.spaces.map((space, spaceIndex) =>
                    <Badge key={spaceIndex} variant="outline" className="text-xs" data-id="5t0tgn7n8" data-path="src/components/ProjectPortfolio.tsx">
                          {space}
                        </Badge>
                    )}
                    </div>
                  </div>
                  
                  <div data-id="lhsmyfaxf" data-path="src/components/ProjectPortfolio.tsx">
                    <h4 className="font-semibold text-gray-800 mb-2 text-sm" data-id="tco81lv7t" data-path="src/components/ProjectPortfolio.tsx">Resultados:</h4>
                    <div className="flex flex-wrap gap-2" data-id="ickoql8m0" data-path="src/components/ProjectPortfolio.tsx">
                      {project.results.map((result, resultIndex) =>
                    <Badge key={resultIndex} className="text-xs bg-green-100 text-green-700" data-id="a0yxuvoe7" data-path="src/components/ProjectPortfolio.tsx">
                          {result}
                        </Badge>
                    )}
                    </div>
                  </div>
                </div>
                
                <Button
                className="w-full mt-4 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white"
                size="sm" data-id="c3bcmj3o2" data-path="src/components/ProjectPortfolio.tsx">

                  <Eye className="w-4 h-4 mr-2" data-id="hthdrags2" data-path="src/components/ProjectPortfolio.tsx" />
                  Ver Detalles
                </Button>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-8 lg:p-12" data-id="6fsw1cg2w" data-path="src/components/ProjectPortfolio.tsx">
          <div className="grid md:grid-cols-4 gap-8 text-center" data-id="zmt92561h" data-path="src/components/ProjectPortfolio.tsx">
            <div data-id="9q1y78f3d" data-path="src/components/ProjectPortfolio.tsx">
              <div className="text-4xl font-bold text-blue-600 mb-2" data-id="d0bojic6t" data-path="src/components/ProjectPortfolio.tsx">500+</div>
              <div className="text-gray-600" data-id="yedfy8ebt" data-path="src/components/ProjectPortfolio.tsx">Proyectos Completados</div>
            </div>
            <div data-id="qt11mlsbp" data-path="src/components/ProjectPortfolio.tsx">
              <div className="text-4xl font-bold text-green-600 mb-2" data-id="1th0yizn4" data-path="src/components/ProjectPortfolio.tsx">98%</div>
              <div className="text-gray-600" data-id="gxlu1c084" data-path="src/components/ProjectPortfolio.tsx">Satisfacción del Cliente</div>
            </div>
            <div data-id="3rcsjedri" data-path="src/components/ProjectPortfolio.tsx">
              <div className="text-4xl font-bold text-purple-600 mb-2" data-id="60jyllri5" data-path="src/components/ProjectPortfolio.tsx">35%</div>
              <div className="text-gray-600" data-id="ojau2i5in" data-path="src/components/ProjectPortfolio.tsx">Ahorro Energético Promedio</div>
            </div>
            <div data-id="fv427atdo" data-path="src/components/ProjectPortfolio.tsx">
              <div className="text-4xl font-bold text-orange-600 mb-2" data-id="hc9z1wt2s" data-path="src/components/ProjectPortfolio.tsx">24/7</div>
              <div className="text-gray-600" data-id="kwlzu51xj" data-path="src/components/ProjectPortfolio.tsx">Soporte Técnico</div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center" data-id="oo8p7v76r" data-path="src/components/ProjectPortfolio.tsx">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-8 lg:p-12 text-white" data-id="qpsyegba4" data-path="src/components/ProjectPortfolio.tsx">
            <h3 className="text-3xl font-bold mb-4" data-id="dt6d2pgkb" data-path="src/components/ProjectPortfolio.tsx">
              ¿Listo para tu Próximo Proyecto?
            </h3>
            <p className="text-lg opacity-90 mb-8 max-w-2xl mx-auto" data-id="k2nlcyyys" data-path="src/components/ProjectPortfolio.tsx">
              Contáctanos y descubre cómo podemos transformar tu espacio en el hogar inteligente que siempre has soñado.
            </p>
            <Button
              size="lg"
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-4 font-medium" data-id="81wiiynhm" data-path="src/components/ProjectPortfolio.tsx">

              Inicia tu Proyecto
              <ArrowRight className="w-5 h-5 ml-2" data-id="9apu23n9m" data-path="src/components/ProjectPortfolio.tsx" />
            </Button>
          </div>
        </div>
      </div>
    </section>);

};

export default ProjectPortfolio;